import { RegularBenefitVariant } from '../../../../../../../typings'

export const EMPTY_FORMULA = {
  type: RegularBenefitVariant.Formula as const,
  expression: '',
}

export const NAME = 'expression'
